import React, { useRef, useEffect } from 'react';
import './app-download.scss';
import QR from 'qrcode.react';
import { BACK, ENTER } from '../../util/remoteButtons';

function AppDownload({ selectedBtn, closeAppDownload, props }) {
  // console.log(selectedBtn);
  const close = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (close.current) close.current.focus();
    }, 100);
  }, [close]);

  const handleOnKeyDown = (e) => {
    e.stopPropagation();
    switch (e.which) {
      case ENTER:
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        closeAppDownload();
        break;
    }
  };

  return (
    <div className="download">
      <p className="download__text1">Scan to Download</p>

      <p className="download__text2">
        {`Scanning this QR code will take you to the ${
          selectedBtn === 'ios' ? 'Apple app ' : 'Google Play '
        } store to download the Blackdove Smartphone app`}
      </p>

      <div className="download__qrcode">
        {/* <QR value={props.app.SCAPDeviceId} size={220} renderAs="svg" /> */}
        <img
          className="download__qrcode__logo"
          src={selectedBtn === 'ios' ? 'assets/img/iOSQRCode.svg' : 'assets/img/AndroidQRCode.svg'}
          alt=""
        />
      </div>

      <button className="download__close" onKeyDown={handleOnKeyDown} onClick={closeAppDownload} ref={close}>
        Close
      </button>
    </div>
  );
}

export default AppDownload;
